import React from 'react'
import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { Broker } from '@/types'
import { fontSizes, fontWeights } from '@/styles'
import { isEmptyOrNull } from '@/utils'
import CdnImage from '@/components/cdn-image'

const BrokerName = styled.span`
  font-size: ${fontSizes.regular};
  font-weight: ${fontWeights.medium};
`

const LogoContainer = styled.div`
  position: relative;
  display: flex;
  height: 45px;
  width: 80px;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`

const BrokerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start !important;
  gap: 16px;
`
const ConactInfoColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const Subtitle = styled.span`
  font-size: ${fontSizes.small};
`

const BrokerInfo = ({ broker }: { broker: Broker }) => {
  const { t } = useTranslation()
  const logo = broker?.logo?.location || broker?.logo

  if (isEmptyOrNull(broker)) return null

  return (
    <BrokerContainer>
      {!!logo && (
        <LogoContainer>
          <CdnImage
            src={logo as string}
            sizes="80px"
            layout="fill"
            placeholder="blur"
            objectFit="contain"
            alt={`${broker?.name || 'Broker'} Logo`}
          />
        </LogoContainer>
      )}
      <ConactInfoColumn>
        <Subtitle>
          {t('listing:b.listing.view.brokerage.text', 'Brokerage')}
        </Subtitle>
        <BrokerName>{broker?.name}</BrokerName>
      </ConactInfoColumn>
    </BrokerContainer>
  )
}

export default BrokerInfo
